import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { cmsApi } from 'common/api/cmsApi';
import { mapsModalSlice } from 'common/components/GoogleMapsModal/GmapsModalSlice';
import { timeframeSwitcherSlice } from 'common/components/TimeframeSwitcher/timeframeSwitcherSlice';
import { authSlice } from 'features/auth/authSlice';
import { confirmationModalSlice } from 'features/confirmation-modal/slice';
import { payrollSlice } from 'features/harvest-payroll/PayrollSlice';
import { seasonSlice } from 'features/navbar/components/SeasonSelector/seasonSlice';
import { daySelectorSlice } from 'features/pick-schedule-views/components/PickSchedule/DaySelectorSlice';
import { psfQuerySlice } from './psfQuerySlice';
import { sentryReduxEnhancer } from './sentryReduxSetup';

export const createAppStore = (
  options?: ConfigureStoreOptions['preloadedState'] | undefined,
) =>
  configureStore({
    reducer: {
      [cmsApi.reducerPath]: cmsApi.reducer,

      // Slices
      [authSlice.name]: authSlice.reducer,
      [confirmationModalSlice.name]: confirmationModalSlice.reducer,
      [psfQuerySlice.name]: psfQuerySlice.reducer,
      [daySelectorSlice.name]: daySelectorSlice.reducer,
      [seasonSlice.name]: seasonSlice.reducer,
      [timeframeSwitcherSlice.name]: timeframeSwitcherSlice.reducer,
      [payrollSlice.name]: payrollSlice.reducer,
      [mapsModalSlice.name]: mapsModalSlice.reducer,
    },

    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(cmsApi.middleware),

    enhancers: getDefaultEnhancers =>
      getDefaultEnhancers().concat(sentryReduxEnhancer),

    ...options,
  });

export const store = createAppStore();

// Enable RTK Query's automatic refetching on reconnect.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
